<template>
    <v-container id="footer-menu-address-wrapper" class="pa-0" fluid>
        <v-row column>
            <v-col
                v-if="primaryContact && primaryContact[$i18n.locale]"
                cols="12"
            >
                <BlockContent
                    :blocks="primaryContact[$i18n.locale]"
                    :serializers="serializers"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import serializers from '~/util/sanity/serializers'
export default {
    name: 'ContentAddress',
    data() {
        return { serializers }
    },
    computed: {
        primaryContact() {
            return this.$store.state.common.siteSettings.primaryContactInfo
                .content
        }
    }
}
</script>
